import { CustomersList } from "./customersList";
import { Breadcrumb, Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import "./customers.css";
import Title from "../UI/Title/Title";
import { useMutation, useQuery } from "react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getContactTypes } from "../../api/contactType";
import { getCurrencyDropdown } from "../../api/currency";
import { Link } from "react-router-dom";
import AddButton from "../UI/AddButton/addbutton";
import ResetButton from "../UI/ResetButton/resetbutton";
import { getCustomers } from "../../api/customers";
import { Search } from "../UI/Search/Search";
import { getCountriesDropdown } from "../../api/countries";
import { FilterInput } from "../UI/FilterApi/filterapi";

function Customers() {
  //API Search
  const [search, setSearch] = useState<string>("");
  const [paginatedCustomers, setPaginatedCustomers] = useState<any>();
  const [page, setPage] = useState<number>(1);
  const [formatedCountries, setFormatedCountries] = useState<{}[]>();
  const [formatedCurrency, setFormatedCurrency] = useState<{}[]>();
  const [formatedContactType, setFormatedContactType] = useState<{}[]>();
  const [, setInitialValues] = useState({ active: undefined });
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const navigate = useNavigate();
  const [tableKey, setTableKey] = useState("");

  const resetFilters = () => {
    CustomerMutation({ limit: page * 10 + 10, q: "" }).then((res) => {
      setPaginatedCustomers(res.data.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const { isLoading: loadingContactType } = useQuery(
    "contactTypes",
    getContactTypes,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedContactType(
          res.data.map((contactType: any) => {
            return { value: contactType.id, label: contactType.typeName };
          })
        );
      },
    }
  );
  const { isLoading: loadingCurrency } = useQuery(
    "currencies",
    getCurrencyDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedCurrency(
          res.data
            .map((curr: any) => {
              if (curr.isActive) {
                return { value: curr.id, label: curr.symbol };
              }
              return null;
            })
            .filter((curr: any) => curr !== null)
        );
        if (res.data.length > 0) {
          setInitialValues({ active: res.data[0].id });
        }
      },
    }
  );

  const { mutateAsync: CustomerMutation, isLoading: isCustomerLoading } =
    useMutation("customers", getCustomers);

  const handleSearch = () => {
    CustomerMutation({ limit: page * 10 + 10, q: search }).then((res) => {
      setPaginatedCustomers(res.data.data);
    });
  };
  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    CustomerMutation({
      limit: page * 10 + 10,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedCustomers(res.data.data);
    });
  };
  const { t } = useTranslation("common");

  const { isLoading: loadingCountries } = useQuery(
    "countries",
    getCountriesDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedCountries(
          res.data
            ?.map((country: any) => {
              if (country.isActive) {
                return { value: country.id, label: country.name };
              } else {
                return null;
              }
            })
            .filter((country: any) => country !== null)
        );
        if (res.data.length > 0) {
          setInitialValues({ active: res.data[0].id });
        }
      },
    }
  );

  return (
    <>
      <Row gutter={[10, 10]} style={{ width: "100%" }}>
        <Col offset={1}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("sales")}</>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">{t("customers-list")}</span>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          <Title title={`${t("customers-list")}`} />
        </Col>

        <Col
          style={{ display: "flex", justifyContent: "flex-start" }}
          span={4}
          offset={1}
        >
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
            onEnter={() => {
              handleSearch();
            }}
          />
        </Col>

        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>

        <Col
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          offset={14}
          span={2}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton
            onClick={() => {
              navigate(`/customers/create`, {
                state: {
                  formatedCurrency: formatedCurrency,
                  loadingCurrency: loadingCurrency,
                  formatedContactType: formatedContactType,
                  loadingCopntactType: loadingContactType,
                  formatedCountries: formatedCountries,
                  loadingCountries: loadingCountries,
                },
              });
            }}
          />
        </Col>
        <Col offset={1} span={22}>
          <CustomersList
            CustomerMutation={CustomerMutation}
            isCustomerLoading={isCustomerLoading}
            search={search}
            paginatedCustomers={paginatedCustomers}
            setPaginatedCustomers={setPaginatedCustomers}
            page={page}
            setPage={setPage}
            tablekey={tableKey}
          />
        </Col>
      </Row>
    </>
  );
}

export default Customers;
